<template>
	<div class="w-full dropdown-group">
		<button
			class="btn btn-dropdown"
			@click.stop.prevent="CheckAll()"
		>
			<div
				v-if="selectable"
				class="form-check"
			>
				<input
					type="checkbox"
					class=""
					id="select-all"
					name="select-all"
					:checked="value.checkedAll"
					@change="CheckAll()"
					hidden
				/>
				<label
					class="form-check-label"
					:class="{
						partial: partialGroup && !fullGroup,
						full: fullGroup,
					}"
					for="select-all"
					@click.stop.prevent="CheckAll()"
				>
				</label>
			</div>
			<span class="flex-1"> {{ label }} </span
			><i
				class="fas expand-icon"
				:class="{
					'fa-chevron-right': !value.opened,
					'fa-chevron-down': value.opened,
				}"
				@click.stop.prevent="OpenList()"
			></i>
		</button>
		<DropdownList
			v-if="value.opened"
			v-model="newValue.children"
			@fullGroup="fullGroup = $event"
			@partialGroup="partialGroup = $event"
			@selecteds="$emit('selecteds', $event)"
		/>
	</div>
</template>

<script>
	import { useEachRecursively } from '@/composables'
	import DropdownList from './DropdownList.vue'

	export default {
		name: 'Dropdown',
		components: {
			DropdownList,
		},
		model: {
			prop: 'value',
			event: 'change',
		},
		props: {
			value: {
				type: Object,
				required: true,
				default: () => {},
			},
			label: {
				type: String,
				default: '',
			},
			selectable: {
				type: Boolean,
				default: true,
			},
		},
		data() {
			return {
				newValue: {
					opened: false,
					checkedAll: false,
					children: [],
				},
			}
		},
		computed: {
			partialGroup() {
				if (!this.value.children?.length) return false

				let hasChecked = false

				useEachRecursively(this.value?.children, (child, skipRef) => {
					if (child.checked) {
						hasChecked = true
						skipRef.skip = true
						return
					}
				})

				return hasChecked
			},
			fullGroup() {
				if (!this.value.children?.length) return false

				let someNotChecked = true

				useEachRecursively(this.value?.children, (child, skipRef) => {
					if (!child.checked) {
						someNotChecked = false
						skipRef.skip = true
						return
					}
				})

				return someNotChecked
			},
		},
		watch: {
			value: {
				handler(newValue) {
					this.newValue = newValue
				},
				immediate: true,
				deep: true,
			},
			fullGroup: {
				handler(newValue) {
					this.newValue.checkedAll = newValue
					this.$emit('change', this.newValue)
				},
				immediate: true,
			},
		},
		methods: {
			OpenList() {
				this.newValue.opened = !this.newValue.opened
				this.$emit('change', this.newValue)
			},
			CheckAll() {
				this.newValue.checkedAll = !this.newValue.checkedAll

				useEachRecursively(this.newValue?.children, child => {
					child.checked = this.newValue.checkedAll
				})

				this.$emit('change', this.newValue)
			},
		},
	}
</script>

<style lang="scss" scoped>
	.expand-icon {
		padding: 0.5rem 0.7rem;
		color: var(--white);
		font-size: 1.5rem;
	}
</style>
